import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submitButton", "charCount", "prompt"]

  declare submitButtonTarget: HTMLButtonElement
  declare charCountTarget: HTMLElement
  declare promptTarget: HTMLTextAreaElement

  declare hasCharCountTarget: boolean
  declare hasPromptTarget: boolean

  connect() {
    this.updateCount()
  }

  showLoading() {
    this.submitButtonTarget.classList.add("loading")
    this.submitButtonTarget.disabled = true
  }

  hideLoading() {
    this.submitButtonTarget.classList.remove("loading")
    this.submitButtonTarget.disabled = false
  }

  updateCount() {
    if (this.hasCharCountTarget && this.hasPromptTarget) {
      const length = this.promptTarget.value.length
      this.charCountTarget.textContent = `${length}/500`
    }
  }
}
